import { useEffect, useState } from "react";

import jBox from "jbox";
import $ from "jquery";

const ModalAlertDeletePartner = ({
  open = false,
  onClose = (closeDeletePartner) => {},
  onConfirm = (confirmDeletePartner) => {},
}) => {
  const [modal, setModal] = useState(null);

  const openModal = () => {
    modal.open();
  };
  /* First event render */
  useEffect(() => {
    const initModal = new jBox("Modal", {
      closeButton: false,
      closeOnClick: false,
      minWidth: 325,
      maxWidth: 375,
      content: $("#ModalDeleteMember"),
    });
    setModal(initModal);

    return () => {
      initModal.destroy();
    };
  }, []);
  /* End First event render */

  useEffect(() => {
    // console.log("modalQrCode useEffect2!! >>", modalQrCode, open);

    if (modal && open) {
      openModal();

      const btnCloseModal = document.getElementById("btnCloseDeletePartner");
      const btnConfirmModal = document.getElementById(
        "btnConfirmDeletePartner"
      );

      const handleCloseClick = () => {
        if (modal) {
          modal.close();
        }
        onClose(true);
      };

      const handleConfirmClick = () => {
        if (modal) {
          modal.close();
        }
        onConfirm(true);
      };

      if (btnCloseModal) {
        btnCloseModal.addEventListener("click", handleCloseClick);
      }

      if (btnConfirmModal) {
        btnConfirmModal.addEventListener("click", handleConfirmClick);
      }

      // Cleanup function to remove event listeners
      return () => {
        if (btnCloseModal) {
          btnCloseModal.removeEventListener("click", handleCloseClick);
        }
        if (btnConfirmModal) {
          btnConfirmModal.removeEventListener("click", handleConfirmClick);
        }
      };
    }
  }, [modal, open, onClose, onConfirm]);

  return (
    <div className="bModal bCard" id="ModalDeleteMember">
      <div className="bInner">
        <div className="bDetail">
          <p>ยืนยันลบพาร์ทเนอร์?</p>
        </div>
        <div className="group-Btn">
          <div className="modlaBtn" id="btnConfirmDeletePartner">
            <a className="confirmBtn">ยืนยัน</a>
          </div>
          <div
            className="modlaBtn outline btnCloseModal"
            id="btnCloseDeletePartner"
          >
            <a className="">ยกเลิก</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAlertDeletePartner;
